// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type MontecarloSimulationResp } from '@shared/data-access/interfaces/api/ai/montecarlo';

interface TransformedObject {
  id: string;
  data: { x: string; y: number }[];
}

export const transformSimulationData = (
  simulation: MontecarloSimulationResp[],
  amount: number,
): TransformedObject[] => {
  return simulation.map(item => {
    const id = `${item.quantile * 100}th PERCENTILE`;

    const data = [
      { x: 'Y0', y: amount },
      ...item.total_position.map((value, index) => ({
        x: `Y${index + 1}`,
        y: value,
      })),
    ];

    return { id, data };
  });
};
